import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import ImagePlaceholder from "./img-placeholder.svg";

export const StyledImagePlaceholder = styled(ImagePlaceholder)`
  inline-size: 100%;
  block-size: 100%;
`;

export const PlaceHolderContainer = styled.div``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  block-size: 100%;
  padding: 28px;

  font-family: ${fontRobotoCondensed};

  border-radius: 12px;

  background-color: #ecebe3;
`;
